import './relatedAccountList.scss';
import React, { useState, useEffect, useContext } from 'react';
import If from '../../../../common/components/if';
import { AppContext } from '../../../../context/appContext';
import UserAvatar from '../../../../common/businessCommon/user/userAvatar/userAvatar';
import UserName from '../../../../common/businessCommon/user/userName/userName';
import { deleteSwitchedAccount, getLoginedList } from '../../../../dataServices/authDataService';
import { IRelatedAccountInfo, IRelatedAccountList } from '../../../../interface/relatedAccount';
import { CustomDialog } from '../../../../common/components/modalDialog';
import { AllRelatedAccountList } from '../allRelatedAccountList/allRelatedAccountList';
import { PlainText } from '../../../plainText/plainText';
import Loading from '../../../../common/components/loading/loading';
import useSwitchAccount from '../../../../hooks/useSwitchAccount';
import { defaultAvatars } from '@umu/umu-util';
import { AUTH } from '../../../../common/utils/umuUtil';

const [unsetEnterpriseDefaultAvatar] = defaultAvatars;

/**
 * 从切换账户入口进入登录页面，添加额外参数以记录到账户列表
 */
function getToAddAccountURL() {
    return AUTH.LOGIN_PAGE + `?switch_account=1`;
}

export function RelatedAccountList() {
    const appContext = useContext(AppContext);
    const { state } = appContext;
    const [isDeleting, setDeleting] = useState(false);
    const [previewList, setPreviewList] = useState<IRelatedAccountList>({
        list: [],
        total: 0,
    });
    const [isPreviewListLoading, setPreviewListLoading] = useState(true);

    const { isSwitching, onSwitchAccount } = useSwitchAccount(state.lang);

    const loadPreviewList = async () => {
        const ret = await getLoginedList(3);
        if (ret.data) {
            setPreviewList(ret.data);
        }
        setPreviewListLoading(false);
    };

    useEffect(() => {
        loadPreviewList();
    }, []);

    const renderItem = (item: IRelatedAccountInfo) => {
        return (
            <div key={item.user_token} className="account-item" onClick={() => onSwitchAccount(item)}>
                <div className="account-item-wrap">
                    <div className="account-item-avatar">
                        <UserAvatar
                            // 此处需要考虑不同企业的默认头像问题，故此处需要给未设置过任何企业默认头像的企业用户一个默认头像
                            src={item.avatar || unsetEnterpriseDefaultAvatar}
                            className="data-user-avatar"
                            width={48}
                            showUserLevel={0}
                        />
                    </div>
                    <div className="account-item-info">
                        <div className="account-item-info-wrap">
                            <div className="account-item-info-name truncate-text">
                                <UserName
                                    name={item.user_name}
                                    className="data-user-name"
                                    showUserLevel={0}
                                    transcate={true}
                                />
                            </div>
                            <div className="account-item-info-display-account truncate-text">{item.account}</div>
                            <div className="account-item-info-enterprise-name truncate-text">
                                {item.enterprise_name}
                            </div>
                        </div>
                    </div>
                    <div
                        className="account-item-delete"
                        onClick={(e) => {
                            onDeleteAccount(e as unknown as Event, item);
                        }}
                    ></div>
                </div>
            </div>
        );
    };

    const onDeleteAccount = ($event: Event, account: IRelatedAccountInfo) => {
        setDeleting(true);
        deleteSwitchedAccount(account.user_token).then(function (ret) {
            if (ret.data) {
                loadPreviewList();
            }
            setDeleting(false);
        });
        $event.stopPropagation();
        $event.preventDefault();
        return false;
    };

    const showDialog = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.preventDefault();
        evt.stopPropagation();

        CustomDialog({
            className: 'account-list-dialog',
            canClose: true,
            width: '6rem',
            childProps: {
                userInfo: state.userInfo,
                lang: state.lang,
                enterpriseInfo: state.enterpriseInfo,
            },
            contentComponent: AllRelatedAccountList,
        });
    };

    if (isPreviewListLoading) {
        return (
            <div>
                <Loading />
            </div>
        );
    }

    const addAccountUrl = getToAddAccountURL();

    return (
        <div>
            <If condition={previewList.total === 0}>
                <div className="account-list-operator">
                    <div className="account-list-operator-container">
                        <a href={addAccountUrl} className="action">
                            <i className="icon-header">+</i> <PlainText>添加账户</PlainText>
                        </a>
                    </div>
                </div>
            </If>

            <If condition={previewList.total > 0}>
                <div className={`account-list related-account-list ${isSwitching || isDeleting ? 'is-switching' : ''}`}>
                    <div className="account-list-header clearfix">
                        <a href={addAccountUrl} className="header-action">
                            <i className="icon-header">+</i> <PlainText>添加账户</PlainText>
                        </a>
                        <div className="header-title">
                            <PlainText>切换账户</PlainText>
                        </div>
                    </div>
                    <div className="account-list-body">
                        {previewList.list.map((item) => {
                            return renderItem(item);
                        })}
                    </div>
                    <If condition={previewList.total > 3}>
                        <div className="account-list-footer">
                            <div className="footer-action" onClick={showDialog}>
                                <a href="#" className="btn">
                                    <PlainText>查看全部账户</PlainText>
                                </a>
                            </div>
                        </div>
                    </If>
                </div>
            </If>
        </div>
    );
}
